import Box from '@mui/material/Box'

import type { FilterOption } from '@models/Filter'
import type { Gebied } from '@models/Gebied'

import { Grid } from '../../../../theme/components/Grid'
import { useKpi } from '../../hooks/useKpi'
import type { Kpi } from '../../types/Kpi'

import { KpiTile } from './KpiTile'
import { KpisFilters } from './KpisFilters'
import {
  generateCombiOpdrachtenQuery,
  generateProjectenQuery,
  isKpi,
  isOpdrachtKpi,
  isProcesstap,
} from './kpi-util'

interface Props {
  selectedTab: string
  filterOptions: {
    gebieden: Gebied[]
    netbeheerders: string[]
    coordinerendeAannemers: string[]
    labels: FilterOption[]
  }
  onClickTile: (query: any, url: string) => void
}

export const Kpis = ({ selectedTab, filterOptions, onClickTile }: Props) => {
  const {
    data: kpis,
    onChangeFilters,
    filters,
    initialFilters,
    onRefresh,
    onReset,
  } = useKpi()

  const handleClickKpi = (kpi: Kpi, kpiColor?: string) => {
    const { query, url } = isOpdrachtKpi(kpi)
      ? generateCombiOpdrachtenQuery({ filters, kpi, kpiColor })
      : generateProjectenQuery({ filters, kpi, kpiColor })

    onClickTile(query, url)
  }

  return (
    <>
      <KpisFilters
        onChange={onChangeFilters}
        filters={filters}
        initialFilters={initialFilters}
        filterOptions={filterOptions}
        onRefresh={onRefresh}
        onReset={onReset}
      />

      {selectedTab === 'processtappen' && (
        <Box sx={{ p: '50px', ml: '20px' }}>
          <Grid sx={{ width: '100%' }} container spacing={2}>
            {kpis.filter(isProcesstap).map((kpi) => (
              <Grid key={kpi.statusText}>
                <KpiTile kpi={kpi} onClickTile={handleClickKpi} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {selectedTab === 'kpis' && (
        <Box sx={{ p: '50px', ml: '20px' }}>
          <Grid sx={{ width: '100%' }} container spacing={2}>
            {kpis.filter(isKpi).map((kpi) => (
              <Grid key={kpi.statusText}>
                <KpiTile
                  kpi={kpi}
                  onClickTile={handleClickKpi}
                  showKpiActions
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  )
}
